import React from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { sleepScoreList, TEXTS } from './UserProfileScreen';

function UserOnboardingProfileModal({ isOpen, closeModal, userProfile }: { isOpen: boolean; closeModal: () => void; userProfile: any }) {
	const onboarding = userProfile?.onboardingProfile;

	if (!onboarding) return null;

	return (
		<ReactModal
			isOpen={isOpen}
			onAfterOpen={() => {}}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 7,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 600,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  ' style={{ paddingLeft: 20, paddingRight: 20 }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>

				<div className='bg-white rounded-xl px-5 py-5'>
					<Row label='Overall feeling'>{onboarding.overallScore ? TEXTS.find((item: any) => item.value === onboarding.overallScore)?.text : 'No overall score set'}</Row>

					<Row label='Needs help with'>{onboarding.userNeedHelpWith?.length ? onboarding.userNeedHelpWith.map((i: any) => i.name).join(', ') : '/'}</Row>

					<Row label='Struggles with'>{onboarding.userStruggles?.length ? onboarding.userStruggles.map((i: any) => i.name).join(', ') : '/'}</Row>

					<Row label='Check-in frequency'>
						<div className='text-right'>
							<p>{onboarding.checkInFrequency?.name}</p>
							<p className='text-sm text-gray600'>{onboarding.checkInFrequency?.description}</p>
						</div>
					</Row>

					<Row label='Activity'>{onboarding.activity?.length ? onboarding.activity.map((i: any) => i.name).join(', ') : '/'}</Row>

					<Row label='Sleep'>
						{onboarding.sleepScore ? (
							<>
								<p>{sleepScoreList.find((i: any) => i.value === onboarding.sleepScore)?.name}</p>
								<p className='text-sm text-gray600'>{sleepScoreList.find((i: any) => i.value === onboarding.sleepScore)?.description}</p>
							</>
						) : (
							'No sleep score set'
						)}
					</Row>

					<Row label='Interested in course'>{onboarding.interestedCourse?.length ? onboarding.interestedCourse.map((i: any) => i.title).join(', ') : '/'}</Row>

					<Row label='Notifications'>{onboarding.notificationSettings?.name ?? 'No notifications set'}</Row>
				</div>
			</div>
		</ReactModal>
	);
}

export default UserOnboardingProfileModal;

const Row = ({ label, children }: { label: string; children: React.ReactNode }) => (
	<>
		<div className='flex justify-between mt-5 gap-4'>
			<p className='text-gray600 font-semibold text-[16px]'>{label}</p>
			<div className='text-gray600 font-medium text-[16px] text-right'>{children}</div>
		</div>
		<div className='border-b border-b-gray300 mt-5' />
	</>
);
